/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailsRequest
 */
export interface UserDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserDetailsRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsRequest
     */
    lastName: string;
    /**
     * The phone number we could obtain for the user if any.
     * @type {string}
     * @memberof UserDetailsRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailsRequest
     */
    optOutFromNewsletter: boolean;
    /**
     * The country code of the user, if any.
     * @type {string}
     * @memberof UserDetailsRequest
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the UserDetailsRequest interface.
 */
export function instanceOfUserDetailsRequest(value: object): value is UserDetailsRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('optOutFromNewsletter' in value) || value['optOutFromNewsletter'] === undefined) return false;
    return true;
}

export function UserDetailsRequestFromJSON(json: any): UserDetailsRequest {
    return UserDetailsRequestFromJSONTyped(json, false);
}

export function UserDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'optOutFromNewsletter': json['optOutFromNewsletter'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function UserDetailsRequestToJSON(value?: UserDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'optOutFromNewsletter': value['optOutFromNewsletter'],
        'countryCode': value['countryCode'],
    };
}

